import * as ItemCategoriesModel from "./itemCategoriesModel"

export type Action = 
  | { type: 'ITEM_CATEGORY_ADDED', value: string }
  | { type: 'ITEM_CATEGORY_CHANGED', serverItemCategories: ItemCategoriesModel.ItemCategory[], value: string, itemCategoryId: number }
  | { type: 'ITEM_CATEGORY_DELETED', itemCategoryId: number }
  | { type: 'ITEM_CATEGORY_UNDELETED', itemCategoryId: number }
  | { type: 'ITEM_CATEGORIES_SAVE' }

export const reducer = (state: ItemCategoriesModel.ItemCategoriesState, action: Action): ItemCategoriesModel.ItemCategoriesState => {
  switch(action.type) {
    case 'ITEM_CATEGORY_ADDED':
      return ItemCategoriesModel.addItemCategory(state, action.value)
    case 'ITEM_CATEGORY_CHANGED':
      return ItemCategoriesModel.updateItemCategory(state, action.serverItemCategories, action.itemCategoryId, x => ({ ...x, name: action.value  }))
    case 'ITEM_CATEGORY_DELETED':
      return ItemCategoriesModel.deleteItemCategory(state, action.itemCategoryId)
    case 'ITEM_CATEGORY_UNDELETED':
      return ItemCategoriesModel.undeleteItemCategory(state, action.itemCategoryId)
    case 'ITEM_CATEGORIES_SAVE':
      return ItemCategoriesModel.defaultItemCategoriesState()
    default:
      return state
  }
}